import { AxiosResponse } from "axios";
import PingResult from "../interface/PingResult";
import TraceRouteResult from "../interface/TraceRouteResult";

const AutomatDTO = {
  convertPingResponse: (response: AxiosResponse): PingResult => {
    if (response.data) {
      return {
        automatKey: response.data.automatKey,
        color: response.data.color,
        rawResult: response.data.rawResult,
        resultText: response.data.resultText,
      };
    }
    return {} as PingResult;
  },
  convertTraceResponse: (response: AxiosResponse): TraceRouteResult => {
    if (response.data) {
      return {
        color: response.data.color,
        rawResult: response.data.rawResult,
        resultText: response.data.resultText,
      };
    }
    return {} as TraceRouteResult;
  },
};
export default AutomatDTO;
